import {ref} from "vue";
import {message, TreeProps} from "ant-design-vue";
import {
  QueryRoles,
  QueryUsersByRoleId
} from "../servers/userSelServer";
import {afterLoadUser, deepClone} from "../utils";
import GoingUtils from "@/utils/goingUtils";
import {useI18n} from "vue-i18n";

export function useRoleSel(alreadySelUsers, roleName){
  const {t} = useI18n();
  //展开keys
  const expandedKeys = ref<string[]>([]);
  //机构树
  const roleList:any = ref<TreeProps['treeData']>([]);
  //查询用户列表集合
  const searchUserList=ref([]);
  const curActiveId=ref<string>('');
  const total=ref(0);
  const currentVal=ref(1);
  const pageSize=ref(20);
  const curSelItem=ref({});

  /**
   * 刷新组织机构列表
   */
  const flusRoleList=()=>{
    const params = {
      name: unref(roleName),
      size: GoingUtils.getMaxRecords
    }
    QueryRoles(params,(res)=>{
      if(res){
        roleList.value = deepClone(res.records);
      }
    })
  }

  /**
   * 选择组织架构查询用户
   * @param selectedKeys
   */
  const selRecord=(item, {fromPagination=false}={})=>{
    curSelItem.value=item;
    if(unref(curActiveId)===item.id){
      return;
    }
    if (!fromPagination) {
      currentVal.value=1;
    }
    curActiveId.value=item.id;
    GoingUtils.showLoading();
    unref(searchUserList).splice(0, 1500);
    const parans={roleId:item.id,size:unref(pageSize),current:unref(currentVal)};
    QueryUsersByRoleId(parans,(res)=>{
      GoingUtils.closeLoading();
      afterLoadUser(res,alreadySelUsers,searchUserList);
      if(res.total){
        total.value=res.total;
      }else{
        total.value=searchUserList.value.length;
      }
    })
  }

  const onShowSizeChange=({current, pageSizeNum})=>{
    if (!unref(curActiveId)) {
      message.warning(t('请选择角色'));
      return;
    }
    currentVal.value=current;
    pageSize.value=pageSizeNum;
    curActiveId.value='';
    nextTick(()=>{
      selRecord(unref(curSelItem), {fromPagination: true});
    })
  }


  const columns=[
    {
      title: '角色名称',
      dataIndex: 'roleName',
      key: 'roleName',
    }
  ]
  //查询部门信息
  flusRoleList();
  return {
    onShowSizeChange,
    total,
    pageSize,
    current: currentVal,
    curActiveId,
    columns,
    selRecord,
    searchUserList,
    expandedKeys,
    roleList
  }
}
